import { withStyles } from "@material-ui/core";
import  AddCircle from "@material-ui/icons/AddCircle";
import  AddBox from "@material-ui/icons/AddBox";
import  RemoveCircle from "@material-ui/icons/RemoveCircle";
import { div } from "lqx-react/lib";

export const StyledAddBox = withStyles({
    root: {
        fontSize: 'xx-large',
        color: '#052C4C',
        cursor: 'pointer',
    }
})(AddBox);

export const StyledAddCircle = withStyles({
    root: {
        fontSize: 'xx-large',
        color: '#052C4C',
        cursor: 'pointer',
    }
})(AddCircle);

export const StyledRemoveCircle = withStyles({
    root: {
        fontSize: 'xx-large',
        color: '#052C4C',
        cursor: 'pointer',
    }
})(RemoveCircle);

export const AgGridReactContainer = div({
    height: '150px',
    width: '100%',
    marginBottom: '15px'
});